export default "__VITE_ASSET__q1Oc1Von__"